import { useState, useEffect } from 'react';
import { fg } from '@atlaskit/platform-feature-flags';

const MESSAGE_TYPE = 'embeddedConfluenceVisibleHeight';

export const useIframeVisibleHeight = (
	uniqueKey?: string,
): {
	visibleHeight: number;
} => {
	// The initial height is arbitrarily set to 1000
	const [visibleHeight, setVisibleHeight] = useState(1000);

	useEffect(() => {
		const contentSizeHandler = (postMessage: MessageEvent) => {
			const data = postMessage.data;

			if (
				data?.type === MESSAGE_TYPE &&
				data?.value &&
				(uniqueKey && fg('platform_deprecate_lp_cc_embed') ? data?.uniqueKey === uniqueKey : true)
			) {
				setVisibleHeight(data.value);
			}
		};

		window.addEventListener('message', contentSizeHandler);

		return () => {
			window.removeEventListener('message', contentSizeHandler);
		};
	}, [uniqueKey]);

	return { visibleHeight };
};
